/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from 'react';
import SDPageHeader from '../SDPageHeader';
import { sdGetIssue, sdGetMe, sdGetProjects, sdGetUsers } from 'services/service-desk/sdService';
import { sdCreateRequest, sdMakeRequests, sdRequestsCompleted, sdRenderLoadingOrError } from 'helpers/sdHelper';
import { Col, Row } from 'react-bootstrap';
import SDIssueDetails from './SDIssueDetails';
import SDIssueControls from './SDIssueControls';
import SDIssueActivity from './SDIssueActivity';
import { useParams } from 'react-router-dom';
import SDIssueActions from './SDIssueActions';

const SDIssue = () => {
    const { issueId } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [me, setMe] = useState(null);
    const [projects, setProjects] = useState([]);
    const [issue, setIssue] = useState(null);
    // For testing, remove later
    const [users, setUsers] = useState(null);

    const reloadIssue = async () => {
        sdGetIssue(issueId).then(res => {
            setIssue(res.data);
        }).catch(err => {
            console.error("Faild to reload issue");
        })
    };


    useEffect(() => {
        setLoading(true);
        reloadIssue();
    }, []);

    useEffect(() => {
        if (issue != null) {
            console.log(issue);
            let allRequests = [
                sdCreateRequest(() => sdGetProjects(), setProjects),
                sdCreateRequest(() => sdGetMe(), setMe),
                sdCreateRequest(() => sdGetUsers(issue.project.id), setUsers)];

            sdMakeRequests(allRequests, setLoading, setError);
        }
    }, [issue]);

    if (!sdRequestsCompleted(loading, error) || users == null) {
        return sdRenderLoadingOrError(loading, error);
    }

    // console.log("projects", projects)
    // console.log("issue", issue)
    // console.log("users", users)
    // console.log("me", me)

    return (
        <>
            <SDPageHeader title={`(${issue.key}) ${issue.subject}`} me={me} showCreateIssue></SDPageHeader>

            <Row className="g-3">
                <Col xl={{ span: 4, order: 1 }} >

                    <SDIssueActions issue={issue}></SDIssueActions>
                    <SDIssueControls issue={issue} users={users} me={me} onChange={() => reloadIssue()}></SDIssueControls>
                </Col>
                <Col xl={8}>
                    <SDIssueDetails issue={issue}></SDIssueDetails>
                    <SDIssueActivity issue={issue} onCommentAdded={() => reloadIssue()}></SDIssueActivity>
                </Col>
            </Row>
        </>
    )
}

export default SDIssue;